(() => {
  function getLargestSrc(img) {
    if (img && img.srcset) {
      const candidates = img.srcset
        .split(',')
        .map((part) => {
          const bits = part.trim().split(/\s+/);
          const width = bits[1] && bits[1].endsWith('w') ? parseInt(bits[1], 10) : 0;
          return { url: bits[0], width: Number.isNaN(width) ? 0 : width };
        })
        .filter((item) => item.url)
        .sort((a, b) => a.width - b.width);

      if (candidates.length) return candidates[candidates.length - 1].url;
    }

    return (img && (img.currentSrc || img.src)) || '';
  }

  function init(root) {
    if (!root || root.dataset.vhSofaBenefitGalleryReady === 'true') return;

    const mediaItems = root.querySelectorAll('.vh-sofa-info__benefit-media');
    if (!mediaItems.length) return;

    root.dataset.vhSofaBenefitGalleryReady = 'true';

    const modal = document.createElement('div');
    modal.className = 'vh-sofa-benefit-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Powiększone zdjęcie najważniejszej zalety');
    modal.innerHTML = `
      <button type="button" class="vh-sofa-benefit-modal__backdrop" data-vh-sofa-benefit-close aria-label="Zamknij zdjęcie"></button>
      <button type="button" class="vh-sofa-benefit-modal__close" data-vh-sofa-benefit-close aria-label="Zamknij zdjęcie">&times;</button>
      <div class="vh-sofa-benefit-modal__inner">
        <img src="" alt="" width="1200" height="1200" data-vh-sofa-benefit-img>
      </div>
    `;
    root.appendChild(modal);

    const modalImg = modal.querySelector('[data-vh-sofa-benefit-img]');
    const closeButton = modal.querySelector('.vh-sofa-benefit-modal__close');
    let opener = null;
    let previousOverflow = '';

    function openGallery(item) {
      const img = item.querySelector('img');
      const src = getLargestSrc(img);
      if (!img || !src) return;

      opener = item;
      previousOverflow = document.documentElement.style.overflow;
      modalImg.src = src;
      modalImg.alt = img.alt || '';
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeGallery() {
      if (modal.hidden) return;
      modal.hidden = true;
      modalImg.src = '';
      modalImg.alt = '';
      document.documentElement.style.overflow = previousOverflow;
      if (opener) opener.focus();
    }

    mediaItems.forEach((item) => {
      const img = item.querySelector('img');
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', `Otwórz zdjęcie: ${(img && img.alt) || 'Najważniejsza zaleta'}`);
      item.addEventListener('click', () => openGallery(item));
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openGallery(item);
        }
      });
    });

    modal.querySelectorAll('[data-vh-sofa-benefit-close]').forEach((button) => {
      button.addEventListener('click', closeGallery);
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeGallery();
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('.vh-product-info--sofa').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
